import appGlobal from '@/appGlobal';
import useAuth from '@/stores/auth';
import utils from '@/utils';
import React, { useCallback } from 'react';
import { isAndroid } from 'react-device-detect';

export const TYPE_POST_MESSAGE = {
  LOAD_COMPLETE: 'LOAD_COMPLETE',
  RELOAD_HEALTH_DATA: 'RELOAD_HEALTH_DATA',
  EMR_BOOKING: 'EMR_BOOKING',
  VIEW_FILE: 'VIEW_FILE',
  VIEW_SCREEN: 'VIEW_SCREEN',
  UN_VIEW_SCREEN: 'UN_VIEW_SCREEN',
  CLOSE_VIEW: 'CLOSE_VIEW',
};

export const TYPE_ON_MESSAGE = {
  REGISTER_USER: 'REGISTER_USER',
};

const useMessageWebview = () => {
  const loginWithToken = useAuth((s) => s.loginWithToken);
  //Handle Reload data Home
  const handleMessaging = useCallback(
    (event: any) => {
      const { data: eventData } = event ?? {};
      const message = utils.isJsonString(eventData) ? JSON.parse(eventData) : {};
      const { type, data } = message;
      if (!type || !data) return;
      switch (type) {
        case TYPE_ON_MESSAGE.REGISTER_USER:
          appGlobal.isWebview = true;
          loginWithToken(data);
          break;
      }
    },
    [loginWithToken],
  );

  // React.useEffect(() => {
  //   const tokenExample = "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI1MmI1MWExMy0xM2ViLTQyZTQtOTc4NS1jMGYwZDYwZTI0ZTUiLCJzdWIiOiI2Mzg4Iiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNzEyODA1MDc1LCJleHAiOjE3MTY0MzM4NzV9.pW1SObgOf5L73Iep-Tjp3Nhn2H89nawijd8lCLtWlqo"
  //   loginWithToken({ userToken: tokenExample });
  // }, [loginWithToken])

  React.useEffect(() => {
    if (navigator.appVersion.includes('Android') || isAndroid) {
      document.addEventListener('message', handleMessaging);
    } else {
      window.addEventListener('message', handleMessaging);
    }

    utils.postMessage({
      type: TYPE_POST_MESSAGE.LOAD_COMPLETE,
      data: true,
    });

    return () => {
      if (navigator.appVersion.includes('Android') || isAndroid) {
        document.removeEventListener('message', handleMessaging);
      } else {
        window.removeEventListener('message', handleMessaging);
      }
    };
  }, [handleMessaging]);

  React.useEffect(() => {
    console.log('App version 1.1');
  }, []);

  return {
    handleMessaging,
  };
};

export default useMessageWebview;
